import React, { useContext, useState } from 'react'
import { cardsOptions } from '../../helpers/options/options'
import PlansCards from '../../components/cardPlans'
import { NavBarCollapsableContext } from '../../helpers/context'
import { AppDispatch, useAppDispatch } from '../../redux/store'
import { changePlan } from '../../redux/reducers/urlReducer'
import { getToken } from '../../helpers/utils'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { CircularProgress, Typography } from '@mui/material'

const Plans = () => {
  const { t } = useTranslation()
  const dispatch: AppDispatch = useAppDispatch()
  const classContext = useContext(NavBarCollapsableContext)

  const token = getToken()
  let navigate = useNavigate()
  const [showWait, setShowWait] = useState(false)

  const submitPlan = (planSelected: string) => {
    setShowWait(true)
    updatePlan(planSelected)
  }

  const updatePlan = async (selectedPlan: string) => {
    const body = { plan: selectedPlan }
    try {
      const { payload } = await dispatch(changePlan({ token, body }))
      if (payload && payload.success) {
        toast(`${t('PLAN_CHANGED')}`)
        setShowWait(false)
        navigate('/dashboard')
      } else {
        toast(`${t('ERROR')}`)
        setShowWait(false)
      }
    } catch (error) {
      console.error('Error:', error)
      setShowWait(false)
    }
  }

  return (
    <div className={`container-plans`}>
      <div className={classContext.classes.navbar_padding_left}>
        {showWait ? (
          <div className='circular-progress'>
            <CircularProgress size={50} color='info' />
            <Typography
              fontSize={'25px'}
              color={'#f47524'}
              fontWeight={'Bold'}
              variant='body1'
              style={{ marginTop: '20px' }}
            >
              {t('CHANGING_PLAN')}
            </Typography>
          </div>
        ) : (
          <PlansCards cardsOptions={cardsOptions} selectPlan={submitPlan} />
        )}
      </div>
    </div>
  )
}

export default Plans
